import apiCall from '@/utils/api'

export default {
  list: params => {
    return apiCall.get('config/domains_connectors', { params }).then(response => {
      return response.data
    })
  },
  listOptions: () => {
    return apiCall.options('config/domains_connectors').then(response => {
      return response.data
    })
  },
  search: data => {
    return apiCall.post('config/domains_connectors/search', data).then(response => {
      return response.data
    })
  },
  create: data => {
    return apiCall.post('config/domains_connectors', data).then(response => {
      return response.data
    })
  },

  item: id => {
    return apiCall.get(['config', 'domains_connector', id]).then(response => {
      return response.data.item
    })
  },
  itemOptions: id => {
    return apiCall.options(['config', 'domains_connector', id]).then(response => {
      return response.data
    })
  },
  update: data => {
    return apiCall.patch(['config', 'domains_connector', data.id], data).then(response => {
      return response.data
    })
  },
  sort: data => {
    return apiCall.patch('config/domains_connectors/sort_items', data).then(response => {
      return response
    })
  },
  delete: id => {
    return apiCall.delete(['config', 'domains_connector', id])
  }
}
